import { Box, SvgIconProps, Tooltip, TooltipProps } from '@mui/material';
import { ReactNode } from 'react';

import { InfoIcon } from '@/components/StatusIcons';

export type InfoTipProps = { children: ReactNode; iconSize?: SvgIconProps['fontSize'] } & Omit<
    TooltipProps,
    'title' | 'children'
>;

export const InfoTip = ({ iconSize, children, ...props }: InfoTipProps) => (
    <Tooltip title={children} enterDelay={0} {...props}>
        <Box component="span" sx={{ display: 'inline-block' }}>
            <InfoIcon sx={{ px: '2px', pt: '4px' }} fontSize={iconSize} />
        </Box>
    </Tooltip>
);
